import Dropdown from 'semantic-ui-react/dist/es/modules/Dropdown';
import './Dropdown.css';

export default Dropdown;
